<script>
    import router from "page";
    import { onMount } from "svelte";
    import { isLoading } from "../stores.js";

    import Tabulator from "tabulator-tables";
    import "tabulator-tables/dist/css/tabulator.min.css";

    import { keywordFilter, dateFormatter } from "../utils/utilsTabulator.js";
    import { fetchGet } from "../utils/utilsFetch.js";

    import { client, locale } from "../stores.js";

    export let sku;

    let data, tableElement, table;

    onMount(async () => {
        $isLoading = true;

        data = await fetchGet(`/api/orders`);

        console.log(data);

        table = new Tabulator(tableElement, {
            height: "100%",
            data: data,
            layout: "fitDataFill",
            cellVertAlign: "middle",
            rowClick: (e, row) => {
                let data = row._row.data;
                router(`/orders/${data.ackey}`);
            },
            columns: [
                {
                    title: $locale.date || "",
                    field: "date",
                    formatter: dateFormatter,
                    headerFilter: "input",
                    headerFilterFunc: keywordFilter,
                    headerFilterPlaceholder: "⌕",
                },
                {
                    title: $locale.order || "",
                    field: "ackey",
                    headerFilter: "input",
                    headerFilterFunc: keywordFilter,
                    headerFilterPlaceholder: "⌕",
                },
                {
                    title: $locale.amount || "",
                    field: "value",
                    headerFilter: "input",
                    headerFilterFunc: keywordFilter,
                    headerFilterPlaceholder: "⌕",
                },
                {
                    title: $locale.status || "",
                    field: "status",
                    headerFilter: "input",
                    headerFilterFunc: keywordFilter,
                    headerFilterPlaceholder: "⌕",
                },
            ],
        });

        if ($client.isHiddenPrices) {
            table.hideColumn("value");
        }

        $isLoading = false;
    });
</script>

<div class="container">
    <span class="title">{$locale.orders || ""}</span>
    <div class="content">
        <div class="table" bind:this={tableElement} />
    </div>
</div>

<style>
    .container {
        padding: 10px;
        display: flex;
        height: 100%;
        flex-direction: column;
        gap: 10px;
    }

    .title {
        font-size: 30px;
        font-weight: bold;
    }

    .content {
        overflow: auto;
    }

    .pic {
        margin-right: 10px;
    }

    .info {
        display: flex;
        flex-direction: column;
    }
</style>
